// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsPage_img__Az\\+Iz { width: 13rem }
`, "",{"version":3,"sources":["webpack://./src/news-page/NewsPage.module.css"],"names":[],"mappings":"AAAA,wBAAO,aAAa","sourcesContent":[".img { width: 13rem }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `NewsPage_img__Az+Iz`
};
export default ___CSS_LOADER_EXPORT___;
